import { INodeTemplate } from '@/types/node';
import { Edit } from './edit';
import { Render } from './render';

const template: INodeTemplate = {
  version: 1,
  name: 'Add Web App',
  icon: 'add_box',
  type: 'addtohomescreen',
  tag: 'setup & tools',
  content: {
    description: '',
  },
  override: {
    root: {},
  },
  supports: {
    contexts: ['page'],
    appender: true,
  },
};

export { template, Render, Edit };
